export default "__VITE_ASSET__Bgse_lXv__"